import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "908C13",
        accent: "E3E28D"
      },
      dark: {
        primary: "908C13",
        accent: "E3E28D"
      }
    }
  }
});
